import ForumIcon from '@mui/icons-material/Forum';
import MessageInboxList from './MessageInboxList';

export default {
  list: MessageInboxList,
  icon: ForumIcon,
};
